import { useField } from '~/hooks';
import React from 'react';
import FieldControl from './FieldControl';
import SingleSelect from './SingleSelect';

function MemberTemplateSelect({ templates = [], component: SelectComponent = SingleSelect, ...props }) {
  return (
    <SelectComponent {...props}>
      {templates.map((template) => (
        <option key={template.id} value={template.id}>
          {template.name}
        </option>
      ))}
    </SelectComponent>
  );
}

function FieldMemberTemplateSelect(props) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  return (
    <FieldControl error={error}>
      <MemberTemplateSelect {...field} {...props} />
    </FieldControl>
  );
}

export default MemberTemplateSelect;
export { FieldMemberTemplateSelect };
